"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const CURRENT_YEAR = new Date().getFullYear();

export function Footer() {
    const pathname = usePathname();
    const fromWriters = pathname === "/writers" || pathname?.startsWith("/writers/");
    const suffix = fromWriters ? "?from=writers" : "";

    const links = [
        { label: "Terms of Service", href: `/terms${suffix}` },
        { label: "Privacy Policy", href: `/privacy${suffix}` },
        { label: "About", href: `/about${suffix}` },
        { label: "Contact", href: `/contact${suffix}` },
    ];

    return (
        <footer className="border-t border-border/50 bg-background">
            <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 py-6 sm:flex-row lg:px-12">
                {/* Left: Footer links */}
                <nav className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
                    {links.map((link) => (
                        <Link
                            key={link.label}
                            href={link.href}
                            className="transition-colors hover:text-foreground"
                        >
                            {link.label}
                        </Link>
                    ))}
                </nav>

                {/* Right: Copyright */}
                <p className="text-xs text-muted-foreground">
                    © {CURRENT_YEAR} SFF Iloris · All rights reserved.
                </p>
            </div>
        </footer>
    );
}
